import WineLocalsLogoSbg from '../../assets/images/wine_locals_logo.svg'
import { ReactComponent as LogoEvino } from '../../assets/images/logo_evino.svg'

const MainLayout = ({ children }) => (
  <div className="w-full h-full">
    <div className="hidden md:block fixed w-full h-14 bg-white z-10">
      <div className="container flex container mx-auto h-full justify-between items-center">
        <a href={process.env.REACT_APP_WINE_LOCALS_SITE_URL}>
          <img src={WineLocalsLogoSbg} alt="Wine locals" width="70px" height="29px" />
        </a>

        <div className="flex items-center h-full">
          <span className="uppercase font-button mr-6 text-xs">PARCERIA COM</span>

          <a href="https://www.evino.com.br/">
            <LogoEvino alt="Evino" fill="#E4303E" />
          </a>
        </div>
      </div>
    </div>
    {children}
  </div>
)

export default MainLayout
